import { Component, ViewEncapsulation } from '@angular/core';
import { FnGridAbstractCell } from '../../model/fn-grid-abstract-cell.model';

@Component({
    selector: 'fn-grid-number',
    templateUrl: 'fn-grid-number.component.html',
    styleUrls: ['fn-grid-number.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class FnGridNumberComponent extends FnGridAbstractCell {
    override changeAction(val: any) {
        this.cellValue = val;
        this.editToggle();
        this.cellValueChange.emit(this.cellValue);
    }

    override blurAction() {
        this.editToggle();
        this.cellBlur.emit(this.cellValue);
    }

    focusAction() {
        this.cellFocus.emit(this.cellValue);
    }
    override dbClickAction() {
        super.dbClickAction();
    }
}
